import { actualStaffRolesQueryOptions } from '@features/staff-roles/queries'
import { canAccessPortalAdministration } from '@features/portal-administration/access'
import { PortalAdministration } from '@features/portal-administration/components/PortalAdministration'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/admin')({
    beforeLoad: async ({ context }) => {
        if (context.auth.hostMode !== 'staff') {
            throw redirect({ to: '/home' })
        }

        const actualRoles = await context.queryClient.ensureQueryData(actualStaffRolesQueryOptions())
        const canAdminPortal = canAccessPortalAdministration(actualRoles)
        const isDev = actualRoles.includes('dev')

        if (!canAdminPortal && !isDev) {
            throw redirect({ to: '/home' })
        }
    },
    component: RouteComponent,
})

function RouteComponent() {
    return <PortalAdministration />
}
